
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchApplicationByDetails, UpdateJobApplicationByList, UpdateJobApplicationByListForApplication } from '../../features/ApplicationData/ApplicationDataSlice';
import { useParams } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import SearchableDropdown from '../common/SearchableDropdown';
import SearchDropdown from '../common/SearchDropdown';
import JobSearchDropdown from './JobSearchDropdown';
import { Button } from 'rsuite';
import { _baseRequest, COMMON } from '../../utils/baseApi';

interface ApplicationField {
  id: string;
  label: string;
  value: string;
  isEditing: boolean;
  apiField: string;
}

interface CandidateDetailsProps {
  applicationDetails: any;
}

const CandidateDetails: React.FC<CandidateDetailsProps> = ({
  applicationDetails, setapplicationDetails
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const locations = useAppSelector((state) => state.location.locationDetails);

  const [fields, setFields] = useState<ApplicationField[]>([
    { id: 'name', label: 'Name', value: '', isEditing: false, apiField: 'app_name' },
    { id: 'headline', label: 'Headline', value: '', isEditing: false, apiField: 'app_headline' },
    { id: 'phone', label: 'Phone Number', value: '', isEditing: false, apiField: 'app_phone_number' },
    { id: 'email', label: 'Email', value: '', isEditing: false, apiField: 'app_email' },

    { id: 'location', label: 'Location', value: '', isEditing: false, apiField: 'app_location' },

    // { id: 'education', label: 'Education', value: '', isEditing: false, apiField: 'app_education' },
    // { id: 'work', label: 'Work Experience', value: '', isEditing: false, apiField: 'app_work' },
    // { id: 'summary', label: 'Summary', value: '', isEditing: false, apiField: 'app_summary' },
    { id: 'links', label: 'Links', value: '', isEditing: false, apiField: 'app_links' },
    // { id: 'coverLetter', label: 'Cover Letter', value: '', isEditing: false, apiField: 'app_cover_letter' },
    { id: 'source', label: 'Source', value: '', isEditing: false, apiField: 'app_source' },
    { id: 'sourceby', label: 'Source By', value: '', isEditing: false, apiField: 'app_source_by' },
    { id: 'createdAt', label: 'Created At', value: '', isEditing: false, apiField: 'created_at' },
    { id: 'updatedAt', label: 'Updated At', value: '', isEditing: false, apiField: 'updated_at' },
  ]);

  const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string }>();
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [isBookmarking, setIsBookmarking] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [bookMarkRes, setBookMarkRes] = useState(null)


  useEffect(() => {
    setIsLoading(true);
    if (applicationDetails?.application) {
      setFields(fields.map(field => {
        const fieldValue = applicationDetails.application[field.apiField];
        return {
          ...field,
          value: fieldValue || '',
        };
      }));
      setIsLoading(false);
    }
  }, [applicationDetails]);

  const handleEditStart = (fieldId: string) => {
    if (fieldId === 'email' ||
      fieldId === 'createdAt' ||
      fieldId === 'updatedAt'
    ) return;
    setFields(fields.map(field => ({
      ...field,
      isEditing: field.id === fieldId,
    })));
  };

  const handleInputChange = (fieldId: string, value: string) => {
    setFields(fields.map(field =>
      field.id === fieldId ? { ...field, value } : field
    ));
  };

  // validation 
  const validateName = (name: string): boolean => {
    return name.length <= 50;
  };

  const validateHeadline = (headline: string): boolean => {
    return headline.length <= 1000;
  };


  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phone: string): { isValid: boolean; errorMessage: string } => {
    if (phone.length > 18) {
      return { isValid: false, errorMessage: 'Phone number must be 18 characters or less' };
    }

    // // Check if phone is empty
    // if (phone.trim() === '') {
    //   return { isValid: false, errorMessage: 'Phone number is required' };
    // }

    // Use your specific regex pattern for phone validation
    const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/;

    if (!phoneRegex.test(phone)) {
      return { isValid: false, errorMessage: 'Please enter a valid phone number format' };
    }

    return { isValid: true, errorMessage: '' };
  };

  const handlePhoneInputChange = (fieldId: string, value: string) => {
    if (fieldId === 'phone') {
      const phoneRegex = /[+()0-9\s\.\/-]/g;
      const cleanedValue = value.match(phoneRegex)?.join('') || '';
      setFields(fields.map(field =>
        field.id === fieldId ? { ...field, value: cleanedValue } : field
      ));
    } else {
      handleInputChange(fieldId, value);
    }
  };

  const handleUpdate = async (fieldId: string) => {
    const field = fields.find(f => f.id === fieldId);
    if (!field) return;

    let isValid = true;
    switch (fieldId) {
      case 'name':
        isValid = validateName(field.value);
        if (!isValid) toast.error('Name must be 50 characters or less.');
        break;
      case 'headline':
        isValid = validateHeadline(field.value);
        if (!isValid) toast.error('Headline must be 1000 characters or less.');
        break;
      // case 'email':
      //   isValid = validateEmail(field.value);
      //   if (!isValid) toast.error('Please enter a valid email address.');
      //   break;
      case 'phone':
        const phoneValidation = validatePhoneNumber(field.value);
        isValid = phoneValidation.isValid;
        if (!isValid) toast.error(phoneValidation.errorMessage);
        break;
      default:
        break;
    }
    if (!isValid) return;
    try {
      const updatePayload = {
        baseId: Number(baseId),
        applicationId: String(applicationId),
        [field.apiField]: field.value,
      };

      const response = await dispatch(UpdateJobApplicationByListForApplication(updatePayload)).unwrap();

      // Handle successful update
      if (response.status === 200) {
        toast.success(response.message || 'Application updated successfully');
        setFields(fields.map(f => ({
          ...f,
          isEditing: false,
        })));
        const res = await dispatch(fetchApplicationByDetails({ baseId: Number(baseId), jobId: jobId, applicationId: applicationId })).unwrap();
        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
      }
    } catch (error) {
      toast.error(error || 'Failed to update application');
      console.error(`Error updating ${fieldId}:`, error);
    }
  };

  const SkeletonField = () => (
    <div className="animate-pulse">
      <div className="h-3 w-16 bg-gray-200 rounded mb-2"></div>
      <div className="h-6 bg-gray-200 rounded"></div>
    </div>
  );

  const renderLinks = (links: string) => {
    const linkArray = links.split(',').map(link => link.trim());
    return (
      <div className='flex flex-col gap-y-1 w-full'>
     {linkArray.map((link, index) => (
          <a key={index} href={'#'} rel="noopener noreferrer" className=" w-full mt-[0px] px-3 py-[1px] grow font-normal leading-5 transition-colors duration-100 min-h-6
                        placeholder:text-surface-500 outline-indigo-600 focus:outline-none hover:border-[#d1d1db] border-solid border border-transparent rounded-[0.375rem] line-clamp-1">
            {link}
          </a>
        ))} 
      </div>
    );
  };

  // const handleLocationChange = async (newValue: string) => {
  //   setSelectedCountry(newValue);
  //   setFields(fields.map(field =>
  //     field.id === 'location' ? { ...field, value: newValue } : field
  //   ));

  //   const locationField = fields.find(field => field.id === 'location');
  //   if (!locationField) return;

  //   try {
  //     const updatePayload = {
  //       baseId: Number(baseId),
  //       applicationId: String(applicationId),
  //       [locationField.apiField]: newValue?.locationName,
  //     };

  //     const response = await dispatch(UpdateJobApplicationByListForApplication(updatePayload)).unwrap();

  //     if (response.status === 200) {
  //       toast.success(response.message || 'Application updated successfully');
  //     }
  //   } catch (error) {
  //     toast.error(error || 'Failed to update application');
  //     console.error('Error updating location:', error);
  //   }
  // };

  const handleLocationChange = async (newValue: any) => { // Note: changed type from string to any to match the object
    setSelectedCountry(newValue);
    
    // Extract the string value from the object
    const locationString = newValue?.locationName || '';

    setFields(fields.map(field =>
      // Save the string (locationString) instead of the whole object (newValue)
      field.id === 'location' ? { ...field, value: locationString } : field
    ));

    // Find the field object for location
    const locationField = fields.find(field => field.id === 'location');
    if (!locationField) return;

    try {
      const updatePayload = {
        baseId: Number(baseId),
        applicationId: String(applicationId),
        [locationField.apiField]: locationString, // Use the string here
      };

      const response = await dispatch(UpdateJobApplicationByListForApplication(updatePayload)).unwrap();

      // Handle successful update
      if (response.status === 200) {
        toast.success(response.message || 'Application updated successfully');
      }
    } catch (error) {
      toast.error(error || 'Failed to update application');
      console.error('Error updating location:', error);
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';

    const date = new Date(timestamp);

    const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', dateOptions);

    const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
    return `${formattedDate} at ${formattedTime}`;
  };


  const handleBookMarkClick = async () => {
    try {
      setIsBookmarking(true);
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/bookmark.addBookmark`;
      const payload = {
        base_id: baseId,
        app_id: applicationId,
        job_id: jobId
      };

      const response = await _baseRequest(fullUrl, 'POST', payload);
      if (response.status === 200) {
        const res = await dispatch(fetchApplicationByDetails({ baseId: Number(baseId), jobId: jobId, applicationId: applicationId })).unwrap();
        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        toast.success(response.bookmark || 'Bookmark added successfully');
      }
      // Handle successful response here
      return response;
    } catch (error) {
      console.error("Error adding bookmark:", error);
    } finally {
      setIsBookmarking(false);
    }
  };

  const handleBookMarkRemove = async () => {
    try {
      setIsBookmarked(true);
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${applicationDetails?.application?.bookmark_id}/bookmark.deleteBookmark`;


      const response = await _baseRequest(fullUrl, 'DELETE');
      if (response.status === 200) {

        toast.success(response.message || 'Bookmark remove successfully');
        const res = await dispatch(fetchApplicationByDetails({ baseId: Number(baseId), jobId: jobId, applicationId: applicationId })).unwrap();
        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
      }
      return response;
    } catch (error) {
      console.error("Error adding bookmark:", error);
    } finally {
      setIsBookmarked(false);
    }
  };

  return (
    <div className="p-0">
      <Toaster richColors />

      <div className="space-y-3">
        {isLoading ? (
          <div className="space-y-4 px-3">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <SkeletonField key={i} />
            ))}
          </div>
        ) : (
          fields.map((field) => (
            <div key={field.id} className="relative">
              <label className="wg-label px-3 mt-0 inline-flex shrink-0 items-center gap-1 font-normal text-dark-black-200 text-[12px] wg-antialiased leading-4">
              {field.label}
              </label>
              {field.isEditing ? (
                field.id === 'location' ? (

                  <JobSearchDropdown
                    items={locations}
                    buttonText="Search by city, state, or country"
                    onChange={handleLocationChange}
                    selectedItem={selectedCountry}
                    isLoading={loadingLocation}
                  />
                ) : (
                  <input
                    type={field.id === 'phone' ? 'tel' : 'text'}
                    value={field.value}
                    onChange={(e) => field.id === 'phone' ?
                      handlePhoneInputChange(field.id, e.target.value) :
                      handleInputChange(field.id, e.target.value)
                    }
                    onBlur={() => handleUpdate(field.id)}
                    className="flex mt-[0px] w-full grow border px-3 py-0 h-[24px] items-center text-[13px] text-[#374151] font-normal leading-5  transition-colors duration-100 placeholder:text-surface-500
        focus:outline focus:outline-none  hover:border-[#d1d1db] focus:shadow-none focus:border-[#d1d1db] focus:ring-0
         border-transparent rounded-[0.375rem]"
                    autoFocus
                  />
                )
              ) : (
                <div
                  onClick={() => handleEditStart(field.id)}
                  className={` w-full mt-[0px] grow border px-3  py-[1px] h-[26px] items-center text-[13px] text-[#374151] font-normal leading-5 transition-colors duration-100 
                        placeholder:text-surface-500 outline-indigo-600 focus:outline-none hover:border-[#d1d1db] border-transparent rounded-[0.375rem] 
                         ${field.id === 'email' ? ' hover:border-transparent' : ''}
                          ${field.id === 'links' ? ' hover:border-transparent border-none h-full !px-0' : ''}
                          ${field.id === 'createdAt' || field.id === 'updatedAt' ? '  hover:border-transparent' : ''}
                            ${field.id === 'headline' ? 'h-full block break-words min-h-[26px]' : 'flex'}
                         `}
                >
                  {field.id === 'links'
                    ? renderLinks(field.value)
                    : (field.id === 'createdAt' || field.id === 'updatedAt')
                      ? formatTimestamp(field.value)
                      : field.value
                  }
                </div>
              )}
            </div>
          ))
        )}
      </div>
      {
        applicationDetails?.application?.is_bookmarked === true &&
        <button
          onClick={handleBookMarkRemove}

          className='px-3  py-[1px] mt-[1rem] flex items-center gap-x-1'>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="currentColor"
            className="icon icon-tabler icons-tabler-filled icon-tabler-bookmark w-[1rem] h-[1rem] text-[#808080]"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1 -1.555 .832l-5.445 -3.63l-5.444 3.63a1 1 0 0 1 -1.55 -.72l-.006 -.112v-14a5 5 0 0 1 5 -5h4z" />
          </svg>
          Remove Bookmark </button>
      }

      {
        applicationDetails?.application?.is_bookmarked === false &&
        <button
          onClick={handleBookMarkClick}
          className='px-3  py-[1px] mt-[1rem] flex items-center gap-x-1'>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-bookmark w-[1rem] h-[1rem] text-[#808080]"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 7v14l-6 -4l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4z" />
          </svg>

           Add Bookmark </button>
      }

    </div>
  );
};

export default CandidateDetails;